const brandDefault = {
  state: () => ({
    images: {
      sedans: [
        {
          modelName: "Elantra",
          sideView: require("../../../static/images/carcuts/hyundai/side-view/elantra-19.png"),
          angleView: require("../../../static/images/carcuts/hyundai/angle-view/elantra-19.png"),
          trims: ["SE", "SEL", "Value Edition", "Eco", "Sport", "Limited"]
        },
        {
          modelName: "Accord",
          sideView: require("../../../static/images/carcuts/honda/side-view/accord21.png"),
          angleView: require("../../../static/images/carcuts/honda/angle-view/hondaaccord.png"),
          trims: ["LX", "Sport", "Sport Special Edition", "EX-L", "Touring"]
        },
        {
          modelName: "Q60",
          sideView: require("../../../static/images/carcuts/infiniti/side-view/q60-20.png"),
          angleView: require("../../../static/images/carcuts/infiniti/angle-view/q60-20.png"),
          trims: ["Pure", "Luxe", "Red Sport 400"]
        },
        {
          modelName: "Camry",
          sideView: require("../../../static/images/carcuts/toyota/side-view/Toyota-2019-Camry-2.png"),
          angleView: require("../../../static/images/carcuts/toyota/angle-view/camry.png"),
          trims: ["LE", "SE", "SE Nightshade", "XLE", "XSE", "TRD", "XLE V6", "XSE V6"]
        },
      ],
      suvs: [
        {
          modelName: "Outlander",
          sideView: require("../../../static/images/carcuts/mitsubishi/side-view/outlander-es-red-compressor.png"),
          angleView: require("../../../static/images/carcuts/mitsubishi/angle-view/outlander-18.png"),
          trims: ["ES 2.5 2WD", "Black Edition", "SE 2.5 2WD", "SE Tech", "SE Special Edition", "SEL", "SEL Touring"]
        },
        {
          modelName: "Telluride",
          sideView: require("../../../static/images/carcuts/kia/side-view/Telluride-Red.png"),
          angleView: require("../../../static/images/carcuts/kia/angle-view/telluride-21.png"),
          trims: ["LX", "S", "EX", "SX"]
        },
        {
          modelName: "Rogue",
          sideView: require("../../../static/images/carcuts/nissan/side-view/rogue_side.png"),
          angleView: require("../../../static/images/carcuts/nissan/angle-view/rogue20.png"),
          trims: ["S", "SV", "SL", "Platinum"]
        },
        {
          modelName: "Tucson",
          sideView: require("../../../static/images/carcuts/hyundai/side-view/tucson.png"),
          angleView: require("../../../static/images/carcuts/hyundai/angle-view/tucson-19.png"),
          trims: ["SE", "SEL", "Limited"]
        },
      ],
      trucks: [
        {
          modelName: "Colorado",
          sideView: require("../../../static/images/carcuts/chevrolet/side-view/Colorado2.png"),
          angleView: require("../../../static/images/carcuts/chevrolet/angle-view/colorado-21.png"),
          trims: ["WT", "LT", "Z71", "ZR2"]
        },
        {
          modelName: "Tacoma",
          sideView: require("../../../static/images/carcuts/toyota/side-view/Toyota-2019-Tacoma-2.png"),
          angleView: require("../../../static/images/carcuts/toyota/angle-view/tacoma.png"),
          trims: ["SR", "SR5", "TRD Sport", "TRD Off-Road", "Limited", "TRD Pro"]
        }
      ],
      lifestyleImages: {
        defaultImage: require("../../../static/images/carcuts/kia/lifestyle/kia-jt-bg.jpg"),
        sedanImage: require("../../../static/images/carcuts/infiniti/lifestyle/q60-22.jpg"),
        suvImage: require("../../../static/images/carcuts/toyota/lifestyle/rav4-19.jpg"),
        truckImage: require("../../../static/images/carcuts/chevrolet/lifestyle/silverado-19.jpg")
      },
      videoLink: [
        "https://player.vimeo.com/external/469899806.hd.mp4?s=a24b13682dffae6d68b49ec311d3171069953006&profile_id=175"
      ],
      roundButtons: [
        require("../../../static/images/buttons/round-buttons/default-new.png"), require("../../../static/images/buttons/round-buttons/default-used.png"), require("../../../static/images/buttons/round-buttons/default-service.png"), require("../../../static/images/buttons/round-buttons/default-worth.png")
      ],
      browseButtons: [
        require("../../../static/images/buttons/browse-buttons/black-new.png"), require("../../../static/images/buttons/browse-buttons/black-used.png"), require("../../../static/images/buttons/browse-buttons/black-service.png"), require("../../../static/images/buttons/browse-buttons/black-specials.png")
      ],
      swoopIcons: [
        require("../../../static/images/buttons/swoop-icons/black01.png"), require("../../../static/images/buttons/swoop-icons/black03.png"), require("../../../static/images/buttons/swoop-icons/black02.png")
      ],
      homeBanners: [
        require("../../../static/images/default-homepage-banner.jpg"), require("../../../static/images/banners/kia/CM-PW-24-Kia-Established.jpg"), require("../../../static/images/banners/chevy/CM-JN-24-Chevy-Lifestyle.jpg"), require("../../../static/images/banners/cjdr/CM-BS-24-CJDR-Modern.jpg"), require("../../../static/images/banners/lincoln/CM-SL-CA-Lincoln-Playful.jpg")
      ],
      stripBanners: [
        require("../../../static/images/homepage-strip-banner-default.jpg"), require("../../../static/images/banners/honda/SOKAL-SRS-120921-Clarity-Established.jpeg"), require("../../../static/images/banners/lincoln/SOKAL-SRS-121021-Aviator-Lifestyle.jpeg"), require("../../../static/images/banners/chevy/SOKAL-SRS-Chevy-120921-DealerDraft-Modern.jpeg"), require("../../../static/images/banners/mazda/SOKAL-SRS-112321-DealerDraftMazda-Playful5.jpeg")
      ],
      logoExample: [
        require("../../../static/images/buttons/logos/dd-logo-toyota.png"),
        require("../../../static/images/buttons/logos/dd-logo-toyota-w.png")
      ]
    },
    colors: {
      "--primary-color": "#CC0000",
      "--primary-dark": "#000",
      "--primary-light": "#FFF",
      "--secondary-color": "#900",
      "--secondary-dark": "#333",
      "--secondary-light": "#f5f5f5"
    },
    fonts: {
      "--heading-text": "'Helvetica Neue', Arial, sans-serif",
      "--subheading-text": "'Helvetica Neue', Arial, sans-serif",
      "--body-text": "'Helvetica Neue', Arial, sans-serif",
      "--bold-text": "'Helvetica Neue', Arial, sans-serif"
    }
  })
}


export default brandDefault